<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <form class="form" @submit.prevent="submitPay">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ !advance.isAdvance ? $t('invoices.label.payment_modality') : $t('invoices.label.acompte')}}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                  </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <div class="card-body pb-0">
              <RequiredText />
              <div class="flex-column">
                <div class="row">
                  <InputDate2
                      id="invoices-date"
                      containerClass="col-12 col-md-4 mb-5"
                      :name="`${id}-date`"
                      :label="$t('invoices.label.date')"
                      labelClass="form-label"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true"
                      :placeholder="$t('invoices.label.date')"
                      v-model="formData.date"
                      :parent-id="'#'+id"
                  />
                  <Input
                      containerClass="col-12 col-md-4 mb-5"
                      :name="`${id}-invoice_number`"
                      type="text"
                      :label="$t('invoices.label.invoice_number')"
                      labelClass="form-label"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('invoices.label.invoice_number')"
                      v-model="invoiceNumber"
                      :parent-id="'#'+id"
                      :isDisabled="true"
                  />
                  <Input
                      containerClass="col-12 col-md-4 mb-5"
                      :name="`${id}-customer`"
                      type="text"
                      :label="$t('invoices.label.name')"
                      labelClass="form-label"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('invoices.label.name')"
                      v-model="invoiceContact"
                      :parent-id="'#'+id"
                      :isDisabled="true"
                  />
                </div>
                <div class="row">
                  <InputDate2
                      id="invoices-date-end"
                      containerClass="col-12 col-md-6 mb-5"
                      :name="`${id}-date-end`"
                      :label="$t('invoice.label.deliveryDate')"
                      labelClass="form-label"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="!online"
                      :placeholder="$t('invoice.label.deliveryDate')"
                      v-model="formData.due_date"
                      v-if="advance.isAdvance"
                      :parent-id="'#'+id"
                  />
                  <Select2
                      :is-required="true"
                      container-class="col-12 col-md-6 mb-5"
                      :multiple="false"
                      :show-search="true"
                      :selectClass="'form-select form-control-lg form-select-solid'"
                      v-model="formData.payment_type_id"
                      :parent-id="'#'+id"
                      :name="`${id}-payment-mode`"
                      :label="$t('invoices.label.payment_mode')"
                      label-class="form-label"
                      :placeholder-text="$t('invoices.label.payment_mode')"
                  >
                    <option v-for="paymentType in paymentTypes" :value="paymentType.id" :key="id+paymentType.id">
                      {{ paymentType.name }}
                    </option>
                  </Select2>
                  <InputNumber
                      containerClass="col-12 col-md-6 mb-5"
                      name="payment-amount"
                      :type="formData.type !== 'amount' ? 'number' : 'text'"
                      :label="formData.type !== 'amount' ? $t('invoices.label.percent') : $t('invoices.label.amount')"
                      labelClass="form-label fs-6"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      v-model="formData.value"
                      :readonly="!formData.isAdvance"
                      :min="formData.type !== 'amount' ? 0 : ''"
                      :max="formData.type !== 'amount' ? invoice?.remaining_percent : invoice?.remaining_payment"
                      :placeholder="formData.type !== 'amount' ? $t('invoices.label.percent') : $t('invoices.label.amount')"
                  >
                    <template #rightAddon>
                      <span class="position-absolute end-0 top-50 translate-middle-y me-5 text-muted fw-bolder"> {{ formData.type !== 'amount' ? '%' : currency }} </span>
                    </template>
                  </InputNumber>
                  <InputNumber
                      containerClass="col-12 col-md-6 mb-5"
                      name="payment-amount"
                      type="text"
                      :label="formData.type !== 'amount' ? $t('invoices.label.equivalent') : $t('invoices.remainAmount')"
                      labelClass="form-label fs-6"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      v-model="formData.amount"
                      :placeholder="formData.type !== 'amount' ? $t('invoices.label.equivalent') : $t('invoices.remainAmount')"
                      :readonly="true"
                  >
                    <template #rightAddon>
                      <span class="position-absolute end-0 top-50 translate-middle-y me-5 text-muted fw-bolder"> {{ currency }} </span>
                    </template>
                  </InputNumber>
                </div>
              </div>

              <div class="mb-1" v-if="advance.isAdvance">
                <div class="form-check form-check-custom form-check-solid">
                  <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                         v-model="online"
                         checked="checked" />
                  <label class="form-check-label" for="flexCheckChecked">{{ $t('invoices.advance_paid_text') }}</label>
                </div>
              </div>

              <InputDate2
                  v-show="online"
                  id="invoices-date-payment"
                  containerClass="col-12 col-md-6 mb-5"
                  :name="`${id}-date-end`"
                  :label="$t('invoice.label.paymentDate')"
                  labelClass="form-label"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="online"
                  :placeholder="$t('invoice.label.paymentDate')"
                  v-model="formData.payment_date"
                  :parent-id="'#'+id"
              />

              <div class="row mt 5" v-if="online">
                <div class="col-12 col-md-12 mb-5">
                  <label class="font-weight-600 mb-2" :class="online ? 'required' : ''"> {{ $t('invoices.label.file') }} </label>
                  <UploadFile id="validate_file_upload" size="2" v-model="formData.files"/>
                </div>
              </div>
            </div>
            <div class="row"  v-if="online">
              <div class="col-md-12">
                <cash-deposit v-model="formData" :source-currency="invoice?.currency" :id="id"></cash-deposit>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" background-color="rgba(0, 114, 206, 1)" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoadingValidate"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import Button from "@/components/Button.vue"
import UploadFile from "@/components/UploadFile";
import InputDate2 from "@/components/InputDate2.vue"
import Select2 from "@/components/Select2.vue"
import Input from "@/components/Input.vue";
import InputNumber from "@/components/InputNumber.vue";
import {computed, defineProps, ref, onMounted, watch} from 'vue'
import {useDiscountType} from "@/composables/discountType";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText.vue"
import {formatTodayDate} from "@/mixins/Helpers"
import CashDeposit from "@/Modules/CRM/views/Payment/components/CashDeposit.vue";

const emits = defineEmits(['load'])

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  advance: Object,
  invoice: Object
})
const store = useStore()

const {discountType} = useDiscountType()

const formData = ref(props.advance)
const online = ref(false)

const isLoadingValidate = ref(false)
const currentCompany = Ls.get('current.company')

function closeModal(){
  $('#'+props.id).modal('toggle')
}


watch(() => formData.value.value, (value) => {
  if(value){
    calculAmount()
  }
})

watch(() => online.value, (value) => {
  if(value === true){
    formData.value.status = 'PAID'
    formData.value.payment_date = formatTodayDate()
    formData.value.advancePayment = true
    formData.value.files = []
    formData.value.payment_account_type = "account"
    formData.value.account_id =  ""
    formData.value.box_id = ""
  }else{
    formData.value.status = ''
    formData.value.payment_date = null
    formData.value.files = []
    formData.value.payment_account_type = "account"
    formData.value.account_id =  ""
    formData.value.box_id = ""
  }
})


const paymentTypes = computed(() => store.getters['payments/paymentTypes'])
const invoiceNumber = computed(() => props.invoice?.invoice_number)
const invoiceContact = computed(() => props.invoice?.contact?.fullname)
const invoiceTotal = computed(() => parseFloat(props.invoice?.remaining_payment))
const currency = computed(() => props.invoice?.currency?.symbol)
const accounts = computed(() => store.getters['accounts/getAccounts'])

function calculAmount(){

  let total = parseFloat(formData.value.value)

  if(formData.value.type != "amount"){
    total = (total * parseFloat(props.invoice?.total))/100
  }else{
    if(formData.value.isAdvance){
      total = parseFloat(props.invoice?.remaining_payment) - parseFloat(total)
    }else{
      total = 0
    }
  }

  formData.value.amount = formatDecimal(total)

  return formData.value.amount
}

function formatDecimal(amount) {
  return amount !== 0 ? parseFloat(amount).toFixed(2) : 0
}

function submitPay () {

  isLoadingValidate.value = true
  if(props.advance.isAdvance){
    store.dispatch('invoices/storeAdvanceInvoice', formData.value)
        .then(() => {
          emits('load')
          $('#'+props.id).modal('toggle')
          window.toastr['success'](i18n.global.t('notification.invoice_acompte_paid'))
          formData.value.payment_type_id = ""
          formData.value.date = formatTodayDate()
          formData.value.payment_date = formatTodayDate()
          formData.value.due_date = formatTodayDate()
          formData.value.files = []
          formData.value.payment_account_type = "account"
          formData.value.account_id = ""
          formData.value.box_id = ""
        })
        .catch(() => {
        }).finally(() => isLoadingValidate.value = false)
  }

}


</script>

<style scoped></style>
